import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Login from "./Components/Login/Login";
import OPT_Confirm from "./Components/Login/OPT_Confirm";
import WithdrawlStart_Stop from "./Components/Member/WithdrawlStart_Stop";
import Activation_History from "./Components/Member/Activation_History";
import Activation_Id_By_Zero_Pin from "./Components/Activation/Activation_Id_By_Zero_Pin";
import Zero_Pin_By_5050 from "./Components/Activation/Zero_Pin_By_5050";
import Message from "./Components/Dashboard Message/Message";
import Add_Coin from "./Components/Coin Management/Add_Coin";
import Coin_price from "./Components/Coin Management/Coin_price";
import MessageHistory from "./Components/Dashboard Message/MessageHistory";
import ProtectedRoute from "./Redux/actions/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Buy from "./Components/Trading/Buy";
import Sell from "./Components/Trading/Sell";
import TrandingWithdrawHistory from "./Components/Member/TrandingWithdrawHistory";
import Staking_Claim_History from "./Components/Member/Staking_Claim_History";
import Edit_details from "./Components/Member/Edit_details";
import HelpDesk from "./Components/HelpDesk/HelpDesk";
import Reply from "./Components/HelpDesk/Reply";
import Commission from "./Components/HelpDesk/Commission";
import LoginHistory from "./Components/HelpDesk/LoginHistory";
// import ApprovedKyc  from "./Components/Kyc/ApprovedKyc";
// import PendingKyc from "./Components/Kyc/PendingKyc";
import Manage_subadmin from "./Components/Sub_Admin/Manage_subadmin";
import Subadmin_rights from "./Components/Sub_Admin/Subadmin_rights";
import Edit_subAdmin from "./Components/Sub_Admin/Edit_subAdmin";
import Add_subAdmin from "./Components/Sub_Admin/Add_subAdmin";

import My_Team from "./Components/Team_Reports/My team";
import Contact from "./Components/Contact/Contact";
import Add_HomePageCoin from "./Components/HomePageCoin/Add_HomePageCoin";
import HomePageCoinDetails from "./Components/HomePageCoin/HomePageCoinDetails";
import Update_HomePageCoin from "./Components/HomePageCoin/Update_HomePageCoin";
import RequestToken from "./Components/Request Token/RequestToken";
import RequestTokenUpdate from "./Components/Request Token/RequestTokenUpdate";
import RequestTokenPaid from "./Components/Request Token/RequestTokenPaid";
import RequestTokenCancel from "./Components/Request Token/RequestTokenCancel";
import Active_Member from "./Components/Member/ACTIVE_MEMBER_LIST";
import Level_detail from "./Components/Team_Reports/Level_detail";
import Direct_team from "./Components/Team_Reports/Direct_team";
import Bonus from "./Components/All_Reward/Bonus";
import ActivationByAdmin from "./Components/Activation/ActivationByAdmin";
import Team_Business from "./Components/All_Reward/Team_Business";
import RetopupHistory from "./Components/Member/RetopupHistory";
import Team_Business_Retopup from "./Components/All_Reward/Team_Business_Retopup";
import All_member from "./Components/Member/All_member";
import ZeroPinActivation from "./Components/Zeropin Activation/ZeroPinActivation";
import ZeropinAHistory from "./Components/Zeropin Activation/ZeropinAHistory";
import RoiZeroPinA from "./Components/Zeropin Activation/RoiZeroPinA";
import UpgradeID from "./Components/Activation/UpgradeID";
import ActivationUHistory from "./Components/Activation/ActivationUHistory";
import UserActivationH from "./Components/Activation/UserActivationH";
import DirectLegBusiness from "./Components/Team_Reports/DirectLegBusiness";
import TwoX4XcompleteReport from "./Components/Team_Reports/TwoX4XcompleteReport";
import TwoX4XReport from "./Components/Team_Reports/TwoX4XReport";
import IncomeDeduct from "./Components/Income Deduct/IncomeDeduct";
import IncomeDeductHis from "./Components/Income Deduct/IncomeDeductHis";
import FlushIncome from "./Components/Income Deduct/FlushIncome";
import AddPowerleg from "./Components/Power Leg/AddPowerleg";
import PowerlegHis from "./Components/Power Leg/PowerlegHis";
import RoiRate from "./Components/Power Leg/RoiRate";
import ActivationFund from "./Components/Activation Fund/ActivationFund";
import AfundHistory from "./Components/Activation Fund/AfundHistory";
import ExpiredActivationFund from "./Components/Activation Fund/ExpiredActivationFund";
import Daily_Income from "./Components/Income Reports/Daily_Income";
import Direct_Income from "./Components/Income Reports/Direct_Income";
import Booster_Income from "./Components/All_Reward/Booster_Income";
import LevelIncome from "./Components/Income Reports/LevelIncome";
import Salary_Income from "./Components/Income Reports/Salary_Income";
import TeamMatchingBusiness from "./Components/Income Reports/TeamMatchingBusiness";
import TeamReward_income from "./Components/Income Reports/TeamReward_income";
import Total_incomeReport from "./Components/Income Reports/Total_incomeReport";
import RoiIncome from "./Components/Income Reports/RoiIncome";
import ClosedHelpDesk from "./Components/HelpDesk/ClosedHelpDesk";
import SubadminHistory from "./Components/Sub_Admin/SubadminHistory";
import InvestmentSummary from "./Components/Member/InvestmentSummary";
import LimitOverIncome from "./Components/Income Limit/LimitOverIncome";
import UsdtBonusDetails from "./Components/QR Details/UsdtBonusDetails";
import PendingUsdtRequest from "./Components/QR Details/PendingUsdtRequest";
import UsdtContractHistory from "./Components/QR Details/UsdtContractHistory";
import Rewards from "./Components/Income Reports/Rewards";
import Withdrawal_Pending_List from "./Components/Withdrawal/Withdrawal_Pending_List"
import Withdrawal_Payment_Reports from "./Components/Withdrawal/Withdrawal_Payment_Reports"
import PaidClaimPrincipalWithdrawal from "./Components/Withdrawal/PaidClaimPrincipalWithdrawal";
import PendingClaimPrincipalWithdrawal from "./Components/Withdrawal/PendingClaimPrincipalWithdrawal";
import Withdrawal_Pending_List_Roi from "./Components/Withdrawal/Withdrawal_Pending_List_Roi";
import Withdrawal_Payment_Reports_Roi from "./Components/Withdrawal/Withdrawal_Payment_Reports_Roi";
import Binary_Income from "./Components/All_Reward/Binary_Income";
import DirectBusiness_Income from "./Components/All_Reward/DirectBusiness_Income";
import Websiteenquiryy from "./Components/Income Reports/Websiteenquiryy";
import YouTubeMaster from "./Components/QR Details/YouTubeMaster";
import ChangePassword from "./Components/ChangePassword/ChangePassword";
import LeadershipIncome from "./Components/Income Reports/LeadershipIncome";
import PaidRewards from "./Components/Income Reports/PaidRewards";
function App() {
  // useEffect(() => {
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);

  //   document.addEventListener("keydown", (e) => {
  //     if (
  //       (e.ctrlKey &&
  //         (e.key === "I" ||
  //           e.key === "i" ||
  //           e.key === "u" ||
  //           e.key === "U" ||
  //           e.key === "J" ||
  //           e.key === "j" ||
  //           e.key === "C" ||
  //           e.key === "c")) ||
  //       e.key === "F12"
  //     ) {
  //       e.preventDefault();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route />
          <Route exact path="/" element={<Login />} />
          <Route exact path="/OPT_Confirm" element={<OPT_Confirm />} />
          <Route
            exact
            path="/Dashboard"
            element={<ProtectedRoute component={Dashboard} />}
          />
          <Route
            exact
            path="/Allmember"
            element={<ProtectedRoute component={All_member} />}
          />
          <Route
            exact
            path="/Dashboard_Message"
            element={<ProtectedRoute component={Message} />}
          />
          <Route
            exact
            path="/MessageHistory"
            element={<ProtectedRoute component={MessageHistory} />}
          />

          {/* <Route
            exact
            path="/Coin_Changes"
            element={<ProtectedRoute component={Coin_Changes} />}
          />
          <Route
            exact
            path="/Base_Price"
            element={<ProtectedRoute component={Base_Price} />}
          />
          <Route
            exact
            path="/Change_History"
            element={<ProtectedRoute component={Add_power_leg} />}
          /> */}
          <Route
            exact
            path="/Member_Details"
            element={<ProtectedRoute component={Activation_History} />}
          />
          <Route
            exact
            path="/WithdrawlStart_Stop"
            element={<ProtectedRoute component={WithdrawlStart_Stop} />}
          />
          <Route
            exact
            path="/ActiveMember"
            element={<ProtectedRoute component={Active_Member} />}
          />
          <Route
            exact
            path="/BusinessSummary"
            element={<ProtectedRoute component={InvestmentSummary} />}
          />

          <Route
            exact
            path="/RetopupHistory"
            element={<ProtectedRoute component={RetopupHistory} />}
          />
          <Route
            exact
            path="/Add_Funds"
            element={<ProtectedRoute component={Activation_Id_By_Zero_Pin} />}
          />
          <Route
            exact
            path="/zeropinA"
            element={<ProtectedRoute component={ZeroPinActivation} />}
          />
          <Route
            exact
            path="/zeropinAHistory"
            element={<ProtectedRoute component={ZeropinAHistory} />}
          />
          <Route
            exact
            path="/RoizeropinAHistory"
            element={<ProtectedRoute component={RoiZeroPinA} />}
          />
          <Route
            exact
            path="/Activation"
            element={<ProtectedRoute component={ActivationByAdmin} />}
          />
          <Route
            exact
            path="/ChangePassword"
            element={<ProtectedRoute component={ChangePassword} />}
          />
          
          <Route
            exact
            path="/upgradeid"
            element={<ProtectedRoute component={UpgradeID} />}
          />
          <Route
            exact
            path="/Activationhistory"
            element={<ProtectedRoute component={ActivationUHistory} />}
          />
          <Route
            exact
            path="/userActivationhistory"
            element={<ProtectedRoute component={UserActivationH} />}
          />
          <Route
            exact
            path="/incomededuct"
            element={<ProtectedRoute component={IncomeDeduct} />}
          />
          <Route
            exact
            path="/incomededucthis"
            element={<ProtectedRoute component={IncomeDeductHis} />}
          />
          <Route
            exact
            path="/incomeflushhis"
            element={<ProtectedRoute component={FlushIncome} />}
          />
          <Route
            exact
            path="/roirate"
            element={<ProtectedRoute component={RoiRate} />}
          />
          <Route
            exact
            path="/addpower"
            element={<ProtectedRoute component={AddPowerleg} />}
          />
          <Route
            exact
            path="/powerhistory"
            element={<ProtectedRoute component={PowerlegHis} />}
          />
          <Route
            exact
            path="/activationfund"
            element={<ProtectedRoute component={ActivationFund} />}
          />
          <Route
            exact
            path="/activationfundHis"
            element={<ProtectedRoute component={AfundHistory} />}
          />
          <Route
            exact
            path="/expireactivation"
            element={<ProtectedRoute component={ExpiredActivationFund} />}
          />
          <Route
            exact
            path="/Deduct_Funds"
            element={<ProtectedRoute component={Zero_Pin_By_5050} />}
          />
          <Route
            exact
            path="/Funds_Details"
            element={<ProtectedRoute component={Direct_Income} />}
          />
          <Route
            exact
            path="/bonus"
            element={<ProtectedRoute component={Bonus} />}
          />
            <Route
            exact
            path="/Rewards"
            element={<ProtectedRoute component={Rewards} />}
          />
            <Route
            exact
            path="/Withdrawal_History_Roi"
            element={<ProtectedRoute component={Withdrawal_Payment_Reports_Roi} />}
          />
         
          <Route
            exact
            path="/Pending_Withdrawal_Roi"
            element={<ProtectedRoute component={Withdrawal_Pending_List_Roi} />}
          />
          <Route
            exact
            path="/Withdrawal_History"
            element={<ProtectedRoute component={Withdrawal_Payment_Reports} />}
          />
         
          <Route
            exact
            path="/Pending_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Pending_List} />}
          />
            <Route
            exact
            path="/PaidClaimPrincipalWithdrawal"
            element={<ProtectedRoute component={PaidClaimPrincipalWithdrawal} />}
          />
            <Route
            exact
            path="/PendingClaimPrincipalWithdrawal"
            element={<ProtectedRoute component={PendingClaimPrincipalWithdrawal} />}
          />
          <Route
            exact
            path="/LimitOver"
            element={<ProtectedRoute component={LimitOverIncome} />}
          /><Route
            exact
            path="/Binary_Income"
            element={<ProtectedRoute component={Binary_Income} />}
          />
          
          {/* <Route exact path="/Level_Income" element={<ProtectedRoute component={Level_Income}/>} /> */}
          {/* <Route exact path="/Reward_Income" element={<ProtectedRoute component={Binary_Income}/>} /> */}
          <Route
            exact
            path="/Add_Coin"
            element={<ProtectedRoute component={Add_Coin} />}
          />
          <Route
            exact
            path="/Coin_Base_Price"
            element={<ProtectedRoute component={Coin_price} />}
          />
          <Route
            exact
            path="/Buy"
            element={<ProtectedRoute component={Buy} />}
          />
          <Route
            exact
            path="/Sell"
            element={<ProtectedRoute component={Sell} />}
          />
          <Route
            exact
            path="/DepositeHistory"
            element={<ProtectedRoute component={Staking_Claim_History} />}
          />

          <Route
            exact
            path="/Cancel_Withdrawal"
            element={<ProtectedRoute component={TrandingWithdrawHistory} />}
          />
          <Route
            exact
            path="/Edit_Details"
            element={<ProtectedRoute component={Edit_details} />}
          />
          <Route
            exact
            path="/HelpDesk"
            element={<ProtectedRoute component={HelpDesk} />}
          />
          <Route
            exact
            path="/ClosedHelpDesk"
            element={<ProtectedRoute component={ClosedHelpDesk} />}
          />
          <Route
            exact
            path="/Reply"
            element={<ProtectedRoute component={Reply} />}
          />
          <Route
            exact
            path="/PendingReward"
            element={<ProtectedRoute component={RequestToken} />}
          />
          <Route
            exact
            path="/PaidRewardHistory"
            element={<ProtectedRoute component={RequestTokenPaid} />}
          />
          <Route
            exact
            path="/RequestTokenUpdate"
            element={<ProtectedRoute component={RequestTokenUpdate} />}
          />
          <Route
            exact
            path="/Commission_Report"
            element={<ProtectedRoute component={Commission} />}
          />
          <Route
            exact
            path="/LoginHistory"
            element={<ProtectedRoute component={LoginHistory} />}
          />
          {/* <Route exact path="/ApprovedKyc" element={<ProtectedRoute component={ApprovedKyc}/>} />
        <Route exact path="/PendingKyc" element={<ProtectedRoute component={PendingKyc}/>} /> */}
          <Route
            exact
            path="/Manage_subadmin"
            element={<ProtectedRoute component={Manage_subadmin} />}
          />
          <Route
            exact
            path="/Subadmin_rights"
            element={<ProtectedRoute component={Subadmin_rights} />}
          />
          <Route
            exact
            path="/Edit_SubAdmin"
            element={<ProtectedRoute component={Edit_subAdmin} />}
          />
          <Route
            exact
            path="/Add_SubAdmin"
            element={<ProtectedRoute component={Add_subAdmin} />}
          />
          <Route
            exact
            path="/Daily_Income"
            element={<ProtectedRoute component={Daily_Income} />}
          />
          <Route
            exact
            path="/Direct_Income"
            element={<ProtectedRoute component={Direct_Income} />}
          />
          <Route
            exact
            path="/Booster_Income"
            element={<ProtectedRoute component={Booster_Income} />}
          />
          <Route
            exact
            path="/DirectBusiness_Income"
            element={<ProtectedRoute component={DirectBusiness_Income} />}
          />
          <Route
            exact
            path="/LevelIncome"
            element={<ProtectedRoute component={LevelIncome} />}
          />
          <Route
            exact
            path="/RoiIncome"
            element={<ProtectedRoute component={RoiIncome} />}
          />
          <Route
            exact
            path="/Salary_Income"
            element={<ProtectedRoute component={Salary_Income} />}
          />
          <Route
            exact
            path="/TeamMatchingBusiness"
            element={<ProtectedRoute component={TeamMatchingBusiness} />}
          />
          <Route
            exact
            path="/TeamReward_income"
            element={<ProtectedRoute component={TeamReward_income} />}
          /><Route
            exact
            path="/LeadershipIncome"
            element={<ProtectedRoute component={LeadershipIncome} />}
          />
          <Route
            exact
            path="/Total_incomeReport"
            element={<ProtectedRoute component={Total_incomeReport} />}
          />

          {/* <Route exact path="/Add_MarketCoin" element={<ProtectedRoute component={Add_MarketCoin}/>} /> 
        <Route exact path="/MarketCoinHistory" element={<ProtectedRoute component={MarketCoinHistory}/>} /> 
        <Route exact path="/Update_Coin_Details" element={<ProtectedRoute component={UpdateCoin}/>}/> */}
          <Route
            exact
            path="/My_Team"
            element={<ProtectedRoute component={My_Team} />}
          />
          <Route
            exact
            path="/myreferrals"
            element={<ProtectedRoute component={Direct_team} />}
          />
          <Route
            exact
            path="/DirectLegBusiness"
            element={<ProtectedRoute component={DirectLegBusiness} />}
          />
          <Route
            exact
            path="/TwoX4XcompleteReport"
            element={<ProtectedRoute component={TwoX4XcompleteReport} />}
          />
          <Route
            exact
            path="/TwoX4XReport"
            element={<ProtectedRoute component={TwoX4XReport} />}
          />
          <Route
            exact
            path="/levelDetails"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/Contact_Query"
            element={<ProtectedRoute component={Contact} />}
          />
          <Route
            exact
            path="/Add_HomePageCoin"
            element={<ProtectedRoute component={Add_HomePageCoin} />}
          />
          <Route
            exact
            path="/HomePageCoinDetails"
            element={<ProtectedRoute component={HomePageCoinDetails} />}
          />
          <Route
            exact
            path="/Update_HomePageCoin"
            element={<ProtectedRoute component={Update_HomePageCoin} />}
          />
          <Route
            exact
            path="/RequestTokenCancel"
            element={<ProtectedRoute component={RequestTokenCancel} />}
          />
          <Route
            exact
            path="/Team_Business"
            element={<ProtectedRoute component={Team_Business} />}
          />
          <Route
            exact
            path="/Team_Business_Retopup"
            element={<ProtectedRoute component={Team_Business_Retopup} />}
          />

          <Route
            exact
            path="/UsdtqrDetails"
            element={<ProtectedRoute component={UsdtBonusDetails} />}
          />
           <Route
            exact
            path="/YouTubeMaster"
            element={<ProtectedRoute component={YouTubeMaster} />}
          />
          <Route
            exact
            path="/PendingQRRequest"
            element={<ProtectedRoute component={PendingUsdtRequest} />}
          />
          <Route
            exact
            path="/qrHistory"
            element={<ProtectedRoute component={UsdtContractHistory} />}
          />
          <Route
            exact
            path="/SubadminHistory"
            element={<ProtectedRoute component={SubadminHistory} />}
          />
             <Route
            exact
            path="/Websiteenquiry"
            element={<ProtectedRoute component={Websiteenquiryy} />}
          />
          <Route
            exact
            path="/PaidRewards"
            element={<ProtectedRoute component={PaidRewards} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
